import { axiosInstance } from "@/axios/interceptors";
import { ZodSentryReporter } from "@/lib/zod-sentry-reporter";
import { z } from "zod";

export const LocationByDomainSchema = z.object({
	location_id: z.number(),
	primary_color: z.string(),
	logo: z.string(),
	name: z.string().transform((value) => {
		const locationNameLowerCase = value.toLowerCase();
		const capitalize =
			locationNameLowerCase.charAt(0).toUpperCase() +
			locationNameLowerCase.slice(1);

		// Quickfix: Strip percentage suffixes from Payova location names for UI display
		// Context: Grey uses two Payova locations with different tax rates (10% and 6%).
		// The locations are named "Payova 10%" and "Payova 6%" internally for clarity,
		// but we want to display just "Payova" in the UI.
		// Solution: Detect Payova domain and remove the percentage suffix before rendering.
		if (locationNameLowerCase.includes("payova")) {
			return "Payova";
		}

		return capitalize;
	}),
});

export async function getLocationByDomain(customDomain: string) {
	const response = await axiosInstance.get("/get_location_by_domain", {
		params: {
			custom_domain: customDomain,
		},
	});

	return ZodSentryReporter.parse(LocationByDomainSchema, response);
}
